export default __webpack_public_path__ + "static/media/roadkingrider.7ac31225.jpg";